/**
 * 因子值展示格式化：按各因子原生量纲补单位，解决跨策略数值量级不可比的问题。
 *
 * 量纲约定（与 scripts/run-backtest.js computeFactor 一致）：
 * - 小数收益率：r5/r10/rev5/rev10/mom60/mom120_20/near_high/sharpe60/crash5/crash10
 *   （0.17 = 17%）→ 展示时 ×100 加 %
 * - 百分数原始值：np_yoy / np_accel（净利同比，2026Q2 全A 最大 41.5万%）/ roe
 *   → 直接加 %；极端值折算「万%」（71528.66 → 7.15万%）
 * - 无量纲比率：vr / rsrs / ep / bp / cfq → 保持数值原样
 * - 合成因子（如 r10+rsrs）量纲混合，不做单位换算，保持数值原样
 *
 * 注意：排序走百分位 rank，任何单调变换不改变名次，此处仅影响可读性。
 */
const PCT_DECIMAL_FACTORS = new Set([
  'r5', 'r10', 'rev5', 'rev10', 'mom60', 'mom120_20',
  'near_high', 'sharpe60', 'crash5', 'crash10',
])
const PCT_RAW_FACTORS = new Set(['np_yoy', 'np_accel', 'roe'])

export function formatFactorValue(factor, v) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return '—'
  const n = Number(v)
  const f = String(factor || '')

  // 合成因子量纲混合，不换算
  if (f.includes('+')) return n.toFixed(4)

  if (PCT_RAW_FACTORS.has(f)) {
    // 原始百分数：极端长尾折算万% 保可读性
    if (Math.abs(n) >= 10000) return `${(n / 10000).toFixed(2)}万%`
    if (Math.abs(n) >= 100) return `${n.toFixed(1)}%`
    return `${n.toFixed(2)}%`
  }
  if (PCT_DECIMAL_FACTORS.has(f)) return `${(n * 100).toFixed(2)}%`

  // 无量纲比率组
  return n.toFixed(4)
}
